import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ProductosService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getProductos(idClasificacion:string | number, idMarca:string | number){
    return this.http.get(`${this.API_URI}/productos/todo/${idClasificacion}/${idMarca}`)
  }
  getProducto(id:string){
    return this.http.get(`${this.API_URI}/productos/${id}`);
  }

  actualizarProducto(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/productos/${id}`, datos);
  }
  
  crearProducto(datos: any) {
    return this.http.post(`${this.API_URI}/productos`, datos);
  }

  eliminarProducto(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/productos/${id}`);
  }

  actualizarEstadoImagen(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/productos/estadoImagen/${id}`, datos);
  }

}
